import CaptionElement from "@/app/(site)/_components/GCMolecules/CaptionElement"
import VideoElement from "@/app/(site)/_components/SanityElements/VideoElement"
import { type VideoElementType } from "@/gc-sanity-types"
import { clsx } from "@/src/utils/clsx"
import { generateVideoObjectLdJson } from "@/src/utils/structured-data/videoLdJson"
import { getVideoPlaybackUrl } from "@/src/utils/video/get-video-playback-url"
import { getVideoObjectThumbnailUrl } from "@/src/utils/video/get-video-poster-url"
import { isYouTubeVideoProvider } from "@/src/utils/video/video-provider"

interface VideoGroupProps {
    videos: VideoElementType[]
    className?: string
}

export default function VideoGroup({ videos, className }: VideoGroupProps) {
    return (
        <div className={clsx("h-full w-full", className)}>
            {videos.map((video, index) => {
                const playbackUrl = getVideoPlaybackUrl(video.vimeoId, video.videoFileUrl)
                const videoObjectLdJson = isYouTubeVideoProvider(video.videoProvider)
                    ? generateVideoObjectLdJson(
                          {
                              name: video.name,
                              description: video.description,
                              uploadDate: video.uploadDate,
                              canonicalUrl: video.videoObjectUrl,
                              thumbnailUrl: getVideoObjectThumbnailUrl(video.poster),
                              contentUrl: playbackUrl
                          },
                          `video-object-ld-json-${index}`
                      )
                    : null

                return (
                    <div
                        key={playbackUrl || video.videoObjectUrl || String(index)}
                        className="relative h-full w-full"
                    >
                        {videoObjectLdJson}
                        <figure className="relative h-full w-full">
                            <VideoElement
                                mute={video.mute ?? true}
                                hasSound={video.hasSound ?? false}
                                vimeoId={video.vimeoId}
                                videoFileUrl={video.videoFileUrl}
                                autoplay={video.autoplay}
                                loop={video.loop}
                                poster={video.poster}
                            />
                            {video.caption && <CaptionElement caption={video.caption} />}
                        </figure>
                    </div>
                )
            })}
        </div>
    )
}
